
// state
export const state = {
  windowWidth: false,
  windowHeight: 0
}

// getters
export const getters = {
  checkWindowWidth: state => {
    return state.windowWidth > 1200
  },

  checkWindowCalculation: state => {
    return state.windowWidth > 960
  },

  checkWindowMobileHeight: state => {
    return state.windowHeight < 500
  }

}
// mutations
export const mutations = {
  setWindowWidth (state, payload) {
    state.windowWidth = payload
  },

  setWindowHeight (state, payload) {
    state.windowHeight = payload
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/windowSize.js